/**
 * Centralized legal document version constants.
 *
 * These effective dates are used to:
 * 1. Record which version of a document a user accepted (in `legal_consents`)
 * 2. Determine if a user needs to re-accept after a material document update
 *
 * IMPORTANT: Bump the date here when the corresponding document content changes
 * materially. Users who accepted an older version will be prompted to re-accept.
 */
export const LEGAL_VERSIONS = {
  tos: '2026-04-04',
  privacy_policy: '2026-04-04',
} as const;

/**
 * Users created before this date are grandfathered and will NOT be prompted
 * to accept ToS/Privacy Policy. Only users created on or after this date
 * (including invited users) are subject to the consent gate.
 */
export const CONSENT_GATE_CUTOFF_DATE = '2026-04-04T00:00:00Z';
